import { render, staticRenderFns } from "./SSRApp.vue?vue&type=template&id=a1a5fee8"
import script from "./SSRApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./SSRApp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SSRApp.vue?vue&type=style&index=0&id=a1a5fee8&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports